
import Vue from "vue";
import { Module } from "@/models/module";
import {ModuleService} from "@/services/module-service";
import { IPlanWithMetadata } from "@/models/plan-or-metadata";

export default Vue.extend({
	data(){
		return {
			modules: [] as Module[],
			currentTab: 0
		};
	},
	props: {
		planMetadata: {
			type: Object as ()=> IPlanWithMetadata,
			required: true
		}
	},
	computed: {
		tabs():string[]{
			return [
				"PLAN",
				"RAW"
			];
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		//custom esc Button event
		escButtonEvent(ev:KeyboardEvent){
			if (ev.key === "Escape") {
				this.close();
			}
			return;
		}
	},
	async mounted(){
		let modules = await ModuleService.getModules();
		this.modules = this.planMetadata.plan.getModules(modules);
		window.addEventListener("keyup",this.escButtonEvent);
	},
	beforeDestroy(){
		window.removeEventListener("keyup", this.escButtonEvent);
	},
});
